import { Environment } from './environment.types';

export const environment: Environment = {
  production: false,
  ENV: 'dev',
  MF_VENTA_REMOTE:
    'https://traspasos-dev.afpcapital.cl/mf/vro/remoteEntry.json',
  MF_VENTA_STYLES:
    'https://traspasos-dev.afpcapital.cl/mf/vro/assets/styles.css',
  BASE_BFF: 'https://traspasos-dev.afpcapital.cl/api',
  BASE_BFF_VRA: 'https://traspasos-dev.afpcapital.cl/api/vra/bff',
  BASE_GOOGLE_RECAPTCHA: 'https://www.google.com/recaptcha/enterprise.js',
  BASE_SOVOS: 'https://plugin.autentia.mb:7777/',
  LOGROCKET_APP_ID: 'v71kgw/vro-fxno3',
  LOGROCKET_APP_ID_PUBLICO: 'v71kgw/capi-sex9n',
  SITE_KEY: '6LfukeMqAAAAAGkPLZobcnhwi_7bPVtpvgUPo8UM',
  URL_RENTABILIDAD:
    'https://storage.googleapis.com/src-pwa-2-dev/ot/rentabilidad.json',
  URL_COMISIONES_OBLIGATORIAS:
    'https://storage.googleapis.com/src-pwa-2-dev/ot/comisiones-obligatorias.json',
  URL_COMISIONES_CUENTA_DOS:
    'https://storage.googleapis.com/src-pwa-2-dev/ot/comisiones-cuenta-dos.json',
  SESSION_STORAGE_KEY: 'afp-capital-session',

  GTM_ID: 'GTM-N7GVQZP',
  ABTASTY_ID: '72a6669220c24836b498d7b5e195885f',
  ABTASTY_ENV_ID: 'd8lcsh52mdk000dnrmkg',
  ABTASTY_API_KEY: 'PwSLvxwYulCkuxzhYSggkJvvsDHCEbmdKPiDgJqc',
  FRONT_PUBLICO_URL: 'https://multiproducto.dev.afpcapital.cl',
  BYPASS_VALIDACION_CI: false,
  URL_INVALIDA:
    'https://api.ecertchile.cl/PreviredTVI/api/IntegracionValidacionIdentidad/ValidaPrevired?Id=00000000-0000-0000-0000-000000000000',
};
